import { useContext } from 'react';
import { GameContext } from '../contexts/GameContext.tsx';
import { CellState } from '../types';

interface CellProps {
  state: CellState;
  row: number;
  col: number;
}

export default function Cell({ state, row, col }: CellProps) {
  const gameContext = useContext(GameContext);

  if (!gameContext) return null;

  const handleCellClick = () => {
    if (
      !gameContext.isGameStarted ||
      gameContext.isGameOver ||
      state !== 'alive' ||
      !gameContext.isPlayerTurn
    ) {
      return;
    }
    gameContext.burnCell(row, col);
  };

  const handleMouseEnter = (e: React.MouseEvent) => {
    if (e.buttons === 1) { // Left mouse button is pressed
      handleCellClick();
    }
  };

  return (
    <div
      className={`cell cell-${state} ${
        !gameContext.isGameStarted ||
        gameContext.isGameOver ||
        state !== 'alive' ||
        !gameContext.isPlayerTurn
          ? 'cell-disabled'
          : ''
      }`}
      onClick={handleCellClick}
      onMouseEnter={handleMouseEnter}
      onMouseDown={handleCellClick}
    />
  );
}
